/**
 * Sample a point at the start or end of an SVG path `d` string (canvas coordinates).
 */
export function getPathEndpoint(pathD, which = 'end') {
  if (!pathD || typeof document === 'undefined') return null;

  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('d', pathD);
  const length = path.getTotalLength();
  if (!Number.isFinite(length) || length <= 0) return null;

  const pt = path.getPointAtLength(which === 'start' ? 0 : length);
  return { x: pt.x, y: pt.y };
}

/** Short line segment at the path end — for an invisible arrowhead grab hit area */
export function getPathEndSegment(pathD, segmentLen = 14) {
  if (!pathD || typeof document === 'undefined') return null;

  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('d', pathD);
  const total = path.getTotalLength();
  if (!Number.isFinite(total) || total <= 0) return null;

  const startLen = Math.max(0, total - segmentLen);
  const start = path.getPointAtLength(startLen);
  const end = path.getPointAtLength(total);
  return `M ${start.x} ${start.y} L ${end.x} ${end.y}`;
}
